import jsonLogic from 'json-logic-js';
import isEmpty from 'lodash/isEmpty';
export const validate = (values, attributes, validations) => {
    const attributesKeys = Object.keys(attributes);
    const errors = Object.keys(attributes).reduce((mapped, attributeKey) => {
        if (!attributesKeys.includes(attributeKey)) {
            return mapped;
        }
        const jsonLogicValues = jsonLogic.apply(validations[attributeKey], values);
        mapped[attributeKey] = jsonLogicValues;
        if (((isEmpty(mapped[attributeKey]) ||
            mapped[attributeKey] === true ||
            (Array.isArray(mapped[attributeKey]) &&
                mapped[attributeKey][0] === true)) &&
            attributes[attributeKey]['is_required'] === true &&
            values[attributeKey] === undefined) ||
            (Array.isArray(values[attributeKey]) && isEmpty(values[attributeKey]))) {
            mapped[attributeKey] = attributes[attributeKey]['is_required_message'];
        }
        return mapped;
    }, {});
    const newErrors = Object.keys(errors).reduce((acc, key) => {
        const value = Array.isArray(errors[key])
            ? errors[key].filter((error, index) => error !== true &&
                errors[key].indexOf(error) === index)
            : errors[key];
        if (isEmpty(value) || value === true) {
            return {
                ...acc
            };
        }
        return {
            ...acc,
            [key]: (Array.isArray(value) ? value[0] : value)
        };
    }, {});
    return newErrors;
};
//# sourceMappingURL=validate.js.map